import { render } from "./SuccessfulModalCustom.vue?vue&type=template&id=b1e826a0&ts=true"
import script from "./SuccessfulModalCustom.vue?vue&type=script&lang=ts"
export * from "./SuccessfulModalCustom.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__